// "Select all" for the messages bulk-action bar. Delegated on document so it
// keeps working across Turbo navigations without per-page wiring.
document.addEventListener('change', (event) => {
  const master = event.target.closest('input[type="checkbox"][data-select-all]')
  if (!master) return
  const form = master.closest('form')
  if (!form) return
  form.querySelectorAll('input[type="checkbox"][name="thread_ids[]"]').forEach((box) => {
    box.checked = master.checked
  })
})
